<script>
	import DamageInformationDisplayDesmond from "./DamageInformationDisplayDesmond.svelte";

	export let caseDetails = {};
	export let form;
	export let incidentDateTime;
	export let state;
	export let damageCauseType;
	export let attribution;
	export let damageCause;
	export let staffName;
	export let staffContact;
	export let thirdPartyName;
	export let thirdPartyContact;
	export let vqp;
</script>

<DamageInformationDisplayDesmond
	{caseDetails}
	{form}
	{incidentDateTime}
	{state}
	{damageCauseType}
	{attribution}
	{damageCause}
	{staffName}
	{staffContact}
	{thirdPartyName}
	{thirdPartyContact}
	{vqp}
/>
